import { mainApplication } from "../app";
import * as express from 'express';

/*
 * 版权: Copyright (c) 2018 red
 * 
 * 文件: session.ts
 * 创建日期: Thursday October 25th 2018
 * 作者: pao
 * 说明:
 * 1、
 */

/**
 * Session工具类
 */
export class Session {
    static fromArguments(args?: IArguments) {
        if (args) {
            let req = <express.Request>(args[args.length - 1]);
            return new Session(req);
        }

        return undefined;
    }

    /** Session 工具类 */
    constructor(public req?: express.Request) {
    }

    /**
     * 设置Session
     * @param key 关键字
     * @param value 值
     */
    setValue?(key: string, value: any) {
        this.req.session![key] = value;
        this.req.session!.save(error => {
            if (error) {
                console.log('设置Session [${key}] 异常:' + error.stack);
                throw new Error(`设置Session [${key}] 异常`);
            }
        });
    }

    /**
     * 获取Session
     * @param key 关键字
     */
    getValue?(key: string) {
        return this.req.session![key];
    }
    /**
     * 销毁Session
     * @param key 关键字
     */
    deleteValue?(key: string) {
        this.req.session![key] = undefined;
        this.req.session!.save(error => {
            if (error) {
                console.log('设置Session [${key}] 异常:' + error.stack);
                throw new Error(`设置Session [${key}] 异常`);
            }
        });
    }
}